/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { availableGroupSchema } from "./availableGroupSchema.ts";

export const groupRetrievePathGroupIdSchema = z.uuid();

export const groupRetrievePathOrgUnitIdSchema = z.uuid();

export const groupRetrieveStatus200Schema = availableGroupSchema;

export const groupRetrieveResponseSchema = groupRetrieveStatus200Schema;
